import { useEffect } from 'react';
import Lenis from '@studio-freight/lenis';

// Lightly smoothed scroll on desktop (mouse wheel + keyboard),
// native scroll on touch devices. No overshoot, no snapping.
const SmoothScroll = ({ children }) => {
  useEffect(() => {
    // Respect users who ask for reduced motion — skip Lenis entirely.
    if (typeof window === 'undefined') return undefined;
    const prefersReducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;
    if (prefersReducedMotion) return undefined;

    const lenis = new Lenis({
      duration: 0.9, // tighter than 1.2 — feels responsive, not draggy
      easing: (t) => 1 - Math.pow(1 - t, 3), // ease-out-cubic (no overshoot)
      orientation: 'vertical',
      gestureOrientation: 'vertical',
      smoothWheel: true,
      wheelMultiplier: 1,
      smoothTouch: false, // native scroll on touch — feels right on mobile
      touchMultiplier: 1.5,
      infinite: false,
    });

    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return <>{children}</>;
};

export default SmoothScroll;
